<template>
    <div
        v-if="recommendList && recommendList.length"
        :class="attrType === 'extend' ? 'sg-recommend' : '' "
    >
        <mc-tag
            theme="green"
            type="pure"
        >
            推荐
        </mc-tag>

        <mc-tag
            theme="gray"
            type="unbordered"
            style="margin-left:8px"
        >
            {{ recommendList[0].value }}
        </mc-tag>

        <mc-button
            type="text"
            size="small"
            @click="handleRecommend"
        >
            使用推荐
        </mc-button>
    </div>
</template>

<script>
import { getCurrentInstance } from '@vue/composition-api';

export default {
    name: 'SgRecommend',

    props: {
        recommendList: {
            type: Array,
            default: () => ([]),
        },
        selectedValues: {
            type: [Array, String, Number],
            default: () => ([]),
        },
        attrType: {
            type: String,
            default: 'extend',
        },
    },

    setup() {
        const { proxy, props } = getCurrentInstance();
        const handleRecommend = () => {
            if (props.attrType === 'extend') {
                proxy.$emit('update:selectedValues', props.recommendList);
            } else {
                proxy.$emit('update:selectedValues', props.recommendList[0]?.id);
            }
        };

        return { handleRecommend };
    },
};
</script>

<style lang="scss" scoped>
.sg-recommend{
    margin: -10px 0 10px 130px;
    display: flex;
    align-items: center;
}
</style>
